<template>
  <img ref="img" class="shadow-sm lazy-image" :class="wrapClass" :src="shadowURL" />
</template>

<script>
export default {
  name: "lazy-img",

  props: {
    src: {
      type: String,
      default: "",
    },
    scrollContainer: {
      type: String,
      default: "",
    }
  },

  data() {
    return {
      loaded: false,
      error: false,
      maxWorker: 3,
      shadowURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAtJREFUeJxjYAACAAAFAAF6Xqs/AAAAAElFTkSuQmCC",
    }
  },

  computed: {
    wrapClass() {
      if (this.error) {
        return ['error'];
      }
      if (this.loaded) {
        return ['loaded'];
      }
      return [];
    }
  },

  watch: {
    loaded(newVal) {
      if (newVal) {
        window.removeEventListener("resize", this.handleWindowChange);
        const container = document.querySelector(this.scrollContainer);
        if (container) {
          container.removeEventListener("scroll", this.handleWindowChange);
        }
      }
    }
  },

  mounted() {
    this.handleWindowChange();
    const container = document.querySelector(this.scrollContainer);
    if (container) {
      container.addEventListener("scroll", this.handleWindowChange);
    }
    window.addEventListener("resize", this.handleWindowChange);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowChange);
    const container = document.querySelector(this.scrollContainer);
    if (container) {
      container.removeEventListener("scroll", this.handleWindowChange);
    }
  },

  methods: {
    preload() {
      if (this.loaded) {
        return;
      }
      const workerCounter = window.lazgImageLoading || 0;
      if (workerCounter >= this.maxWorker) {
        setTimeout(this.preload, 500);
        return;
      }
      window.lazgImageLoading = workerCounter + 1;

      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.addEventListener("load", () => {
        this.shadowURL = img.src;
        this.loaded = true;
        window.lazgImageLoading--;
      });
      img.addEventListener("error", () => {
        this.loaded = true;
        this.error = true;
        window.lazgImageLoading--;
      })
      const destURL = this.src.replace(/^(https?:)?\/\//i, "https://");
      img.src = destURL;
    },

    isInViewport(element) {
      const rect = element.getBoundingClientRect();
      return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    },

    handleWindowChange() {
      if (this.$refs.img && this.isInViewport(this.$refs.img)) {
        this.preload();
      }
    }
  }
}
</script>
<style lang="scss">
.lazy-image {
  width: 100px;
  height: 100px;
  background: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' style='margin: auto; background: rgb(255, 255, 255); display: block; shape-rendering: auto;' width='200px' height='200px' viewBox='0 0 100 100' preserveAspectRatio='xMidYMid'%3E%3Ccircle cx='50' cy='50' fill='none' stroke='%232bbbad' stroke-width='10' r='35' stroke-dasharray='164.93361431346415 56.97787143782138'%3E%3CanimateTransform attributeName='transform' type='rotate' repeatCount='indefinite' dur='1s' values='0 50 50;360 50 50' keyTimes='0;1'%3E%3C/animateTransform%3E%3C/circle%3E%3C/svg%3E") #ffffff no-repeat;
  background-size: 50% 50%;
  background-position: center center;

  max-width: 100%;
  max-height: 100%;

  &.loaded {
    width: 100%;
    height: auto;
    background: #ffffff;
  }

  &.error {
    background: url("data:image/svg+xml,%3Csvg t='1690864798350' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='5152' width='16' height='16'%3E%3Cpath d='M512 981.333333c259.2 0 469.333333-210.133333 469.333333-469.333333S771.2 42.666667 512 42.666667 42.666667 252.8 42.666667 512s210.133333 469.333333 469.333333 469.333333z m0 42.666667C229.226667 1024 0 794.773333 0 512S229.226667 0 512 0s512 229.226667 512 512-229.226667 512-512 512z' fill='%232bbbad' p-id='5153'%3E%3C/path%3E%3Cpath d='M706.88 724.266667a21.333333 21.333333 0 1 1-31.616 28.629333A212.992 212.992 0 0 0 516.736 682.666667a213.44 213.44 0 0 0-126.890667 41.6 21.333333 21.333333 0 0 1-25.322666-34.325334A256.085333 256.085333 0 0 1 516.714667 640a255.637333 255.637333 0 0 1 190.165333 84.266667zM330.346667 424.533333l-60.330667 60.330667a21.333333 21.333333 0 0 1-30.165333-30.165333l60.330666-60.352-60.330666-60.330667a21.333333 21.333333 0 0 1 30.165333-30.165333l60.330667 60.330666 60.352-60.330666a21.333333 21.333333 0 1 1 30.165333 30.165333l-60.352 60.330667 60.352 60.352a21.333333 21.333333 0 1 1-30.165333 30.165333l-60.352-60.352zM693.013333 424.533333l-60.330666 60.330667a21.333333 21.333333 0 0 1-30.165334-30.165333l60.330667-60.352-60.330667-60.330667a21.333333 21.333333 0 1 1 30.165334-30.165333l60.330666 60.330666 60.352-60.330666a21.333333 21.333333 0 1 1 30.165334 30.165333l-60.352 60.330667 60.352 60.352a21.333333 21.333333 0 1 1-30.165334 30.165333l-60.352-60.352z' fill='%232bbbad' p-id='5154'%3E%3C/path%3E%3C/svg%3E") #ffffff no-repeat;
    background-size: 50% 50%;
    background-position: center center;
  }
}
</style>
